import {
  Box,
  InputLabel,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormHelperText,
} from '@mui/material'
import Stack from '../Stack.common'
import { GroupProps } from '../../../models/props.models'
import { Info as InfoIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import OwnTooltip from '../Tooltip.common'
const GroupForm: React.FC<GroupProps & { children?: JSX.Element | JSX.Element[] }> = ({
  accordion,
  title,
  children,
  description,
  tooltip,
  error,
  endTitle,
}) => {
  if (accordion) {
    return (
      <Accordion sx={{ margin: '0 5px !important' }} TransitionProps={{ unmountOnExit: true }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <InputLabel error={!!error} sx={{ marginBottom: 0 }}>
            <Stack direction="row" alignItems="center" spacing="6px">
              <Typography variant="h3">{title}</Typography>
              {tooltip && (
                <OwnTooltip title={tooltip}>
                  <InfoIcon color="primary" />
                </OwnTooltip>
              )}
            </Stack>
            {typeof error === 'string' && <FormHelperText error>{error}</FormHelperText>}
          </InputLabel>
          {endTitle && (
            <Box margin="0 5px 0 auto">
              <InputLabel sx={{ marginBottom: 0 }}>
                <Typography variant="h3">{endTitle}</Typography>
              </InputLabel>
            </Box>
          )}
        </AccordionSummary>
        <AccordionDetails>
          {description && (
            <Box mb="20px">
              <Typography>{description}</Typography>
            </Box>
          )}
          {children}
        </AccordionDetails>
      </Accordion>
    )
  }
  return (
    <Stack spacing={2} width="100%">
      {title && (
        <Box mb={description ? '0 !important' : '20px'}>
          <InputLabel error={!!error}>
            <Stack direction="row" alignItems="center" spacing="6px">
              <Typography variant="h3">{title}</Typography>
              {tooltip && (
                <OwnTooltip title={tooltip}>
                  <InfoIcon color="primary" />
                </OwnTooltip>
              )}
            </Stack>
          </InputLabel>
          {typeof error === 'string' && <FormHelperText error>{error}</FormHelperText>}
        </Box>
      )}

      {description && (
        <Box mb="20px">
          <Typography>{description}</Typography>
        </Box>
      )}
      <Box width="100%">{children}</Box>
    </Stack>
  )
}
export default GroupForm
